// api/Siteconfiguration.js
import api from "./axios";

const BASE_URL = "api/admin/site-configuration/";

// GET /api/admin/site-configuration/
// Returns the current config, or throws a 404 if none has been created yet.
export const adminGetSiteConfiguration = () => api.get(BASE_URL);

// POST /api/admin/site-configuration/
// Creates the config. Should only ever be called once (first-time setup).
export const adminCreateSiteConfiguration = (formData) =>
  api.post(BASE_URL, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// PUT /api/admin/site-configuration/
// Updates the existing config, including logo/favicon replacement.
export const adminUpdateSiteConfiguration = (formData) =>
  api.put(BASE_URL, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });